import { API_BASE_URL } from '@/utils/config';

export interface QuoteRequestData {
  name: string;
  email: string;
  phone: string;
  zipCode: string;
  beforeImageUrl: string;
  afterImageUrl: string;
  finishId: string;
  glossLevel: string;
  tenantSlug?: string;
}

export interface QuoteResponse {
  success: boolean;
}

export async function submitQuoteRequest(data: QuoteRequestData): Promise<QuoteResponse> {
  const { tenantSlug, ...body } = data;

  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (tenantSlug && tenantSlug !== 'default') {
    headers['X-Tenant-Slug'] = tenantSlug;
  }

  const response = await fetch(`${API_BASE_URL}/api/v2/quote`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Quote submission failed' }));
    throw new Error(err.error || `Quote error: ${response.status}`);
  }

  return response.json();
}
